import { resetProductState } from "@actions/productActions";
import { TEST_IN_PROGRESS_STATUSES, TestStatus } from "types/testTypes";

const REMEMBERED_DEVICE_KEY = "rememberedDeviceUuid";
const REMEMBERED_DEVICE_SELECTED_AT_KEY = "rememberedDeviceSelectedAt";

export const REMEMBERED_DEVICE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function clearRememberedDevice(): void {
  localStorage.removeItem(REMEMBERED_DEVICE_KEY);
  localStorage.removeItem(REMEMBERED_DEVICE_SELECTED_AT_KEY);
}

export function getRememberedDeviceUuid(): string | null {
  try {
    const uuid = localStorage.getItem(REMEMBERED_DEVICE_KEY);
    if (!uuid) return null;

    const selectedAt = Number(localStorage.getItem(REMEMBERED_DEVICE_SELECTED_AT_KEY));
    const isExpired =
      !Number.isFinite(selectedAt) ||
      selectedAt <= 0 ||
      Date.now() - selectedAt > REMEMBERED_DEVICE_TTL_MS;
    if (isExpired) {
      clearRememberedDevice();
      return null;
    }

    return uuid;
  } catch (error) {
    console.error("Failed to read remembered device from storage:", error);
    return null;
  }
}

export function setRememberedDeviceUuid(uuid: string | null): void {
  try {
    if (uuid) {
      localStorage.setItem(REMEMBERED_DEVICE_KEY, uuid);
      localStorage.setItem(REMEMBERED_DEVICE_SELECTED_AT_KEY, String(Date.now()));
    } else {
      clearRememberedDevice();
    }
  } catch (error) {
    console.error("Failed to store remembered device:", error);
  }
}

interface DeviceSelectionStore {
  getState: () => {
    product: { pid: string | null };
    test: { status: TestStatus };
  };
  dispatch: (action: ReturnType<typeof resetProductState>) => void;
}

export function pruneStaleDeviceSelection(store: DeviceSelectionStore): void {
  const state = store.getState();
  const pid = state.product?.pid;
  if (!pid) return;
  if (TEST_IN_PROGRESS_STATUSES.has(state.test?.status)) return;
  if (getRememberedDeviceUuid() !== pid) {
    store.dispatch(resetProductState());
  }
}
